import React, { FunctionComponent, useEffect, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, withRouter, useHistory } from 'react-router-dom';

import PaymentResponse from './PaymentResponse';
import { showLoader } from '../../Loader/action';
import { fetchPaymentResponse } from '../promiseAction';
import Header from '../../../components/Header';

const Response: FunctionComponent = (props: any) => {
  const history = useHistory();
  const { orderId } = useParams<{ orderId: string }>();

  const dispatch = useDispatch();
  const [responseObj, setResponseObj] = useState({});

  const dispatchLoader = useCallback((payload: any) => dispatch(showLoader(payload)), [dispatch]);

  const dispatchFetchPaymentResponse = useCallback(
    (payload: string) =>
      dispatch(fetchPaymentResponse(payload)).then((resp: any) => {
        dispatchLoader({ show: false });
        const response = resp.data;
        setResponseObj(response);
      }),
    [dispatch, dispatchLoader],
  );

  useEffect(() => {
    dispatchLoader({ show: true });
    dispatchFetchPaymentResponse(orderId);
    // TODO: handle dependencies orderId
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchFetchPaymentResponse, dispatchLoader]);

  const response: any = responseObj;

  return (
    <div>
      <Header title="Add Money to Wallet" history={history}></Header>
      {response.success ? <PaymentResponse data={response.data} /> : null}
    </div>
  );
};

export default withRouter(Response);
